const typeValidate = (fileName, supportedTypes) => {
  if (!supportedTypes.length) return true;
  return supportedTypes.includes(fileName.toLowerCase().split('.').pop())
}
const sizeValidate = (fileSize, supportedSizeMb) => {
  return mbToBytes(supportedSizeMb) >= fileSize
}
const mbToBytes = (mb) => {
  return mb * 1048576
}

const getExtension = (fileName) => {
  return fileName.split('.').pop();
}

const getExtendedTitle = (title, fileName) => {
  if (!title) return fileName;
  const extension = getExtension(fileName);
  return title.endsWith(extension) ? title : `${title}.${extension}`
}

export {
  typeValidate,
  sizeValidate,
  mbToBytes,
  getExtendedTitle
}
